const t = {
  base: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: (e) => e.spacing(4.5),
    height: (e) => e.spacing(4.5),
    border: (e) => e.border(0.25, "white"),
    borderRadius: "9999px",
    fontSize: "10px",
    lineHeight: "12px",
    top: -1,
    right: -1,
    px: 1,
    color: "white",
    transition: "all",
    WebkitTextStrokeWidth: "initial"
  },
  primary: {
    variant: "badges.base",
    bg: "success"
  },
  secondary: {
    variant: "badges.base",
    bg: "secondaryText"
  }
}, i = {
  badges: t
};
export {
  i as badgesTheme
};
